import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const NavBar: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    
    window.addEventListener('scroll', handleScroll);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <nav 
      className={`fixed w-full z-50 transition-all duration-300 ${
        scrolled 
          ? 'bg-green-900 bg-opacity-95 shadow-lg py-2' 
          : 'bg-transparent py-4'
      }`}
    >
      <div className="container mx-auto px-4 flex justify-between items-center">
        <Link to="/" className="flex items-center">
          <svg className="w-10 h-10 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"></path>
          </svg>
          <span className={`text-2xl font-bold ml-2 ${scrolled ? 'text-white' : 'text-white'}`}>
            Zoo Aventure
          </span>
        </Link>
        
        <div className="hidden md:flex space-x-8">
          <Link to="/" className={`${scrolled ? 'text-white' : 'text-white'} hover:text-yellow-400 transition-colors`}>Accueil</Link>
          <Link to="/animaux" className={`${scrolled ? 'text-white' : 'text-white'} hover:text-yellow-400 transition-colors`}>Animaux</Link>
          <Link to="/evenements" className={`${scrolled ? 'text-white' : 'text-white'} hover:text-yellow-400 transition-colors`}>Événements</Link>
          <Link to="/billets" className={`${scrolled ? 'text-white' : 'text-white'} hover:text-yellow-400 transition-colors`}>Billets</Link>
        </div>
        
        <button 
          className="md:hidden text-white focus:outline-none"
          onClick={toggleMenu}
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            {menuOpen 
              ? <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              : <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            }
          </svg>
        </button>
      </div>
      
      {/* Menu mobile */}
      {menuOpen && (
        <div className="md:hidden bg-green-800 bg-opacity-95">
          <div className="container mx-auto px-4 py-2">
            <Link to="/" className="block py-2 text-white hover:text-yellow-400" onClick={() => setMenuOpen(false)}>Accueil</Link>
            <Link to="/animaux" className="block py-2 text-white hover:text-yellow-400" onClick={() => setMenuOpen(false)}>Animaux</Link>
            <Link to="/evenements" className="block py-2 text-white hover:text-yellow-400" onClick={() => setMenuOpen(false)}>Événements</Link>
            <Link to="/billets" className="block py-2 text-white hover:text-yellow-400" onClick={() => setMenuOpen(false)}>Billets</Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default NavBar;
